<div class="wrapper" [class.bottom-right]="position === 'bottomRight'" [class.bottom-left]="position === 'bottomLeft'">
  <div
    class="preview-text"
    *ngIf="showInitialPreviewMessage"
    [class.bottom-right]="position === 'bottomRight'"
    [class.bottom-left]="position === 'bottomLeft'">
    <common-close-icon
      [backgroundColor]="'#E9E9ED'"
      (click)="onClosePreview()"
      class="close-icon"
      [attr.trackable]="trackablePrefix + '/Close initial preview message'"
      [height]="20"
      [width]="20"
      [strokeColor]="'#7A89AD'"></common-close-icon>
    <span> Need help?<span class="branded" (click)="toggleChat()">Start chat</span> </span>
  </div>
  <button id="toggle-chat-button" (click)="toggleChat()" [class.contained]="contained">
    <common-chat-close-icon *ngIf="closeIcon" [class.contained]="contained"></common-chat-close-icon>
    <common-chat-messages-icon *ngIf="messageIcon" [class.contained]="contained"></common-chat-messages-icon>
    <div class="notification-dot" *ngIf="hasNewMessage"></div>
  </button>
</div>
